import { Button, Typography, Card, Tag, Upload } from "antd";
import { SubmitButton, ResetButton } from "formik-antd";
import styled from "styled-components";

export const StyledButton = styled(Button)`
  text-align: center;
  line-height: 20px;
  font-size: 16px;
  border-radius: 6px;
  height: 40px;
  background-color: ${(props) => (props.color ? props.color : "#1565D8")};
  color: ${(props) => (props.textColor ? props.textColor : "#ffffff")};
  &:hover {
    color: #222222;
    background-color: ${(props) => (props.color ? props.color : "#90caf9")};
  }
`;

export const StyledLink = styled.a`
  font-size: 16px;
  color: #6f3ecf;
  &:hover {
    color: #166ae3;
    font-size: 16px;
    font-weight: bold;
  }
`;

export const StyledText = styled(Typography.Text)`
  color: ${(props) => props.textColor};
  &:hover {
    cursor: pointer;
  }
`;

export const StyledTitle = styled(Typography.Title)`
  &:hover {
    cursor: pointer;
    color: ${(props) => props.textColor};
  }
`;

export const StyledFormikSubmitButton = styled(SubmitButton)`
  background-color: #1565d8;
  color: #ffffff;
  &:hover {
    background-color: #64b5f6;
    color: #222222;
  }
`;

export const StyledFormikResetButton = styled(ResetButton)`
  background-color: #a9acb0;
  border: none;
  color: #ffffff;
  &:hover {
    background-color: #a9acb0;
    color: #43474a;
  }
`;

export const StyledCard = styled(Card)`
  width: 426px;
  height: 128px;
  & :focus {
    border-color: #1565d8;
  }
`;

export const StyledCheckTag = styled(Tag.CheckableTag)`
  padding: 6px;
  border: 1px solid #ccc;
  border-color: #90caf9;
  font-size: 16px;
  border-radius: 16px;
  margin: 1vh;
  &:hover {
    cursor: pointer;
  }
  span {
    margin: 0.5vh;
  }
  background-color: ${(props) => (props.checked ? "#2E2EFF" : "#00A9E2")};
  color: ${(props) => (props.checked ? "#f4f4f4" : "#272727")};
`;

export const StyledTag = styled(Tag)`
  padding: 6px;
  border: 1px solid #ccc;
  border-color: #90caf9;
  font-size: 16px;
  border-radius: 16px;
  margin: 1vh;
  span {
    margin: 0.5vh;
  }
  background-color: #00a9e2;
  color: #0f0f0f;
`;

export const SocialButton = styled(Button)`
  text-align: center;
  font-size: 16px;
  height: 40px;
  width: 100%;
  img {
    margin: 2px;
  }
  span {
    margin: 2px;
  }
`;

export const CancelButton = styled(Button)`
  text-align: center;
  font-size: 16px;
  height: 40px;
  width: 100%;
  img {
    margin: 2px;
  }
  span {
    margin: 2px;
  }
  &:hover {
    background-color: #868b8e;
  }
`;

export const StyledUpload = styled(Upload)`
  &:hover {
    cursor: pointer;
  }
`;
